<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getDetails } from "@/api/branch/cod_list";
// import { getExpense } from "@/api/finance/expense";
// import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable,
  },
  props: {
    row: {
      type: Object,
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.row,
      },
      methods: {
        list: (p) => {
          p.id = this.config.rows.id;
          return getDetails(p);
        },
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          Object.keys(data.totalCurrency).forEach((key, index) => {
            data.totalCurrency[key].text =
              this.$t("original") +
              "COD" +
              this.$t("total") +
              this.$t("reChAmount");
            this.totalAmount[index] = data.totalCurrency[key];
          });
          this.totalAmount.push({
            text: this.$t("total") + this.$t("bill_close_account_issuing"),
            replace_currency: "USD",
            total_amount: this.config.rows.total_amount,
          });
        },
      },
      totalAmount: [],
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              this.$page
                .handleRequestMethods("hangDetails", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    parseFloat(item.total_amount)
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          // {
          //   key: "to_country",
          //   placeholder() {
          //     return this.$t("select") + this.$t("countryName");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: { label: "code", value: "code" }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            // {
            //   name: this.$t("hang"),
            //   type: "hang",
            //   fnName: "hang",
            //   bind: {
            //     icon: "md-trash",
            //     type: "error"
            //   },
            //   disabled() {
            //     return (
            //       !this.selectAll.length ||
            //       this.config.rows.status != "WAIT_CONFIRM"
            //     );
            //   },
            //   id: 670
            // },
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   bind: {
            //     icon: "md-trash",
            //     type: "error"
            //   },
            //   disabled() {
            //     return (
            //       !this.selectAll.length ||
            //       this.config.rows.status != "WAIT_CONFIRM"
            //     );
            //   },
            //   id: 670
            // }
          ],
          methods: {
            export({ searchForm }) {
              let data = {
                keywords: searchForm.keywords,
                export: 1,
                ids: this.selectAll.map((item) => item.id),
                id: this.config.rows.id,
              };
              this.handleRequestMethods("list", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                window.open(this.$globalUrl + res.payload);
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          minWidth: 120,
        },
        {
          name: () => this.$t("clientName"),
          key: "account",
          minWidth: 100,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          minWidth: 100,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 100,
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("shipperRef"),
          key: "client_refer_code",
          minWidth: 110,
        },
        {
          name: () => this.$t("agentName"),
          key: "deliver",
          minWidth: 100,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          minWidth: 100,
        },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          minWidth: 120,
        },
        {
          name: () => this.$t("cod_ncnd_9_time"),
          key: "cod_ncnd_9_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("cod_status"),
          key: "cod_status",
          minWidth: 100,
        },
        {
          name: () => this.$t("rate"),
          key: "cod_client_rate",
          minWidth: 100,
        },
        {
          name: () => this.$t("bill_close_account_issuing"),
          key: "bill_close_account_issuing",
          minWidth: 120,
        },
        {
          name: () => this.$t("bill_close_account_issuing_charge"),
          key: "bill_close_account_issuing_charge",
          minWidth: 100,
        },
        {
          name: () => this.$t("bill_close_account_issuing_confirm"),
          key: "bill_close_account_issuing_confirm",
          minWidth: 100,
        },
        {
          name: () => this.$t("cod_1_time"),
          key: "cod_1_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("cod_9_time"),
          key: "cod_9_time",
          minWidth: 170,
        },
      ],
    };
  },
  // async mounted() {
  //   let data = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
  //   this.header.searchs.forEach(item => {
  //     if (item.key === "to_country") item.options = data;
  //   });
  // }
};
</script>
